import { Box } from '@mui/material'
import { CardTitle } from 'components'
import { Body, Container } from './ConsistencyResult.styled'
import { Delivery } from '../../../../../../types'
import { DeliveryStatus } from '../../../../../../components/features/DeliveryStatus/DeliveryStatus'

export const ConsistencyResult = ({ delivery }: { delivery?: Delivery }) => {
  return (
    <Container>
      <Box px="16px">
        <CardTitle title="Consistency" />
      </Box>
      <Body>
        <DeliveryStatus {...delivery?.consistency} />
      </Body>
    </Container>
  )
}
